export const initCountdowns = async () => {
    if (!document.querySelector('.js-countdown:not(.is-countdown-initialized)')) {
        return
    }

    const lang = document.querySelector('html').getAttribute('lang')
    const [ easytimer, locale ] = await Promise.all([
        import('easytimer.js'),
        import(`Locale/${lang}`)
    ])
    const countdownLocale = locale.Countdown
    const { Timer } = easytimer

    const getSeconds = date => {
        const difference = (date - new Date) / 1000

        return { seconds: difference }
    }

    const getHtml = (value, label) => {
        return `<span class="sc-value">${value}${label.charAt(0)}</span><span class="sc-divider"></span>`
    }

    const getString = (timer) => {
        const values = timer.getTimeValues()
        const days = values.days > 0 ? getHtml(values.days, countdownLocale.days) : ''
        const hours = values.days > 0 || values.hours > 0 ? getHtml(values.hours, countdownLocale.hours) : ''
        const minutes = values.days > 0 || values.hours > 0 || values.minutes > 0 ? getHtml(values.minutes, countdownLocale.minutes) : ''
        const seconds = values.days > 0 || values.hours > 0 || values.seconds > 0 ? getHtml(values.seconds.toString().padStart(2, '0'), countdownLocale.seconds) : ''

        return `${days}${hours}${minutes}`
    }

    for (const countdown of document.querySelectorAll('.js-countdown')) {
        if (countdown.classList.contains('is-countdown-initialized')) continue

        const date = new Date(countdown.dataset.time),
            timer = new Timer({ countdown: true })

        timer.start({ startValues: getSeconds(date) })

        timer.addEventListener('secondsUpdated', function (e) {
            countdown.innerHTML = getString(timer)
        })

        timer.addEventListener('targetAchieved', function (e) {
            countdown.innerHTML = ''
        })

        countdown.classList.add('is-countdown-initialized')
    }
}
